import React from "react";
import { Box } from "@mui/material";
import {
  FolderPlusIcon,
  PlusIcon,
  ClipboardDocumentListIcon,
  SparklesIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";

import ButtonComponent from "../customButton";
import ChipComponent from "../chips/ChipComponent/ChipComponent";
import styles from "../../styles/projectPage/projectEmptyScreen.module.scss";

const EMPTY_SCREEN_CONTENT = {
  title: "Create your first project",
  description: "A project holds all your test cases, automation scripts, and test runs in one place. Start by creating a project for your application or team.",
  buttonLabel: "Create Project",
};

const CHIP_ICON_BY_LABEL = {
  "Test Cases": <ClipboardDocumentListIcon className="icon" />,
  "AI Automation": <SparklesIcon className="icon" />,
  "Team access": <UsersIcon className="icon" />,
};

const ProjectEmptyScreen = ({
  onCreate,
  title = EMPTY_SCREEN_CONTENT.title,
  description = EMPTY_SCREEN_CONTENT.description,
}) => {
  const handleCreateClick = () => {
    if (typeof onCreate === "function") {
      onCreate();
    }
  };

  const chipsToRender = Object.keys(CHIP_ICON_BY_LABEL);
  const isCreateDisabled = typeof onCreate !== "function";

  return (
    <Box className={styles.container}>
      <Box className={styles.topIconSection}>
        <FolderPlusIcon className={styles.topIcon} />
      </Box>

      <Box className={styles.textSection}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </Box>

      <Box className={styles.primaryActionSection}>
        <ButtonComponent
          ctaText={EMPTY_SCREEN_CONTENT.buttonLabel}
          variant="primary"
          className="white bg-blue600"
          startIcon={<PlusIcon className="icon" />}
          onClick={handleCreateClick}
          disabled={isCreateDisabled}
        />
      </Box>

      <Box className={styles.secondarySection}>
        <Box className={styles.chipsRow}>
          {chipsToRender.map((chipLabel, index) => (
            <ChipComponent
              key={`${chipLabel}-${index}`}
              variant="blue"
              size="small"
              icon={CHIP_ICON_BY_LABEL[String(chipLabel)] || null}
              className={styles.chip}
            >
              {chipLabel}
            </ChipComponent>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectEmptyScreen;
